<template>
  <div id="Logout">
    <span v-if="type == 'menu'" class="dropdown-item" @click="logout" style="cursor: pointer">
      <div class="dropdown-item-icon">
        <i data-feather="log-out"></i>
      </div>
      Logout
    </span>

    <div v-if="type == 'link'" class="sidenav-footer-subtitle" @click="logout" style="cursor: pointer">Logout</div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    type: "",
  },
  methods: {
    logout() {
      axios.post("/logout").then((res) => {
        if (res.data.status == "success") {
          this.$store.state.authUser = {};
          this.$store.state.authToken = "";
          window.localStorage.removeItem("log_uuid");
          axios.defaults.headers.common["Authorization"] = "Bearer " + process.env.VUE_APP_API_KEY;
          this.$swal("", "Logged out successfully.", "info");
          this.$router.push("/login");
        }
      });
    },
  },
};
</script>

<style>
</style>